import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  EMAILOTP_REQUEST,
  EMAILOTP_SUCCESS,
  EMAILOTP_ERROR
} from "./types";


export function loginRequest(req, cb) {
  return {
    type: LOGIN_REQUEST,
    payload: req,
    cb,
  };
}

export function loginSuccess(res) {
  return {
    type: LOGIN_SUCCESS,
    payload: res,
  };
}

export function loginError(err) {
  return {
    type: LOGIN_ERROR,
    payload: err,
  };
}

export function EmailOTPRequest(req, cb) {
  return {
    type: EMAILOTP_REQUEST,
    payload: req,
    cb,
  };
}

export function EmailOTPSuccess(res) {
  return {
    type: EMAILOTP_SUCCESS,
    payload: res,
  };
}

export function EmailOTPError(err) {
  return {
    type: EMAILOTP_ERROR,
    payload: err,
  };
}